import React from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Avatar,
  Divider,
  Chip
} from '@mui/material';
import { formatActorName } from '../sales/SalesEnquiryUtils';

const formatDateTime = (date) => {
  if (!date) return 'N/A';
  const d = new Date(date);
  return d.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

const RemarksHistory = ({ remarksHistory = [], entityType = 'trip' }) => {
  if (!remarksHistory || remarksHistory.length === 0) {
    return (
      <Box sx={{ py: 2 }}>
        <Typography variant="body2" color="text.secondary" align="center">
          No remarks yet
        </Typography>
      </Box>
    );
  }

  // Sort by createdAt descending (newest first)
  const sortedRemarks = [...remarksHistory].sort((a, b) => {
    const dateA = new Date(a.createdAt || 0);
    const dateB = new Date(b.createdAt || 0);
    return dateB - dateA;
  });

  return (
    <List sx={{ width: '100%' }}>
      {sortedRemarks.map((remark, index) => (
        <React.Fragment key={remark._id || index}>
          <ListItem alignItems="flex-start" sx={{ px: 0 }}>
            <Avatar
              sx={{
                bgcolor: 'primary.main',
                width: 32,
                height: 32,
                mr: 2,
                fontSize: '0.875rem'
              }}
            >
              {formatActorName(remark.createdBy)?.charAt(0)?.toUpperCase() || '?'}
            </Avatar>
            <ListItemText
              primary={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                  <Typography variant="subtitle2" component="span">
                    {formatActorName(remark.createdBy)}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {formatDateTime(remark.createdAt)}
                  </Typography>
                </Box>
              }
              secondary={
                <Typography
                  variant="body2"
                  color="text.primary"
                  sx={{ mt: 0.5, whiteSpace: 'pre-wrap' }}
                >
                  {remark.text}
                </Typography>
              }
            />
          </ListItem>
          {index < sortedRemarks.length - 1 && <Divider component="li" />}
        </React.Fragment>
      ))}
    </List>
  );
};

export default RemarksHistory;
